<template>
    <div>
        <div style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: black;">
            Select Product Category     
        </div>
        <span style="color: #6B7280;font-size:12px" >Select all product category in this section</span>
        <div style="display:flex;justify-content: start;margin-top: 30px;">
            <a-spin :spinning="loading">
                 <a-form-model 
                ref="addCategoryToShopForm"
                :model="addProductCategoryToShop"
                :rules="rules" 
                >

                    <a-form-model-item label="Select Product Group" ref="groupId" prop="groupId">
                        <a-select
                            
                            show-search
                            class="dropdownItem"
                            placeholder="Choose your product"
                            option-filter-prop="children"
                            v-model="addProductCategoryToShop.groupId"
                            @change="onChangeGroup"
                            :filter-option="filterOption"
                        >
                            <a-select-option v-for="group in groups" :key="group.id" v-bind:value="group.id">
                                {{group.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="Select Product Category" ref="categoryId" prop="categoryId">
                        <a-select
                            
                            show-search
                            class="dropdownItem"
                            placeholder="Choose your product"
                            option-filter-prop="children"
                            v-model="addProductCategoryToShop.categoryId"
                            @change="onChangeCategory"
                            :filter-option="filterOption"
                        >
                            <a-select-option v-for="category in categories" :key="category.id" v-bind:value="category.id">
                                {{category.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <small style="color: #9CA3AF;">Product selected in product category will attract {{commission}}% commission</small>


                    <div style="display:flex;justify-content: start; margin-top: 18px;">
                        <a-button @click="saveProductGroup" style="background: #418a49;color:#fff;">
                            Save & Continue
                        </a-button>
                    </div>
                </a-form-model>
            </a-spin>
            
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

    export default {
        name:"EditProductCategory",
        data(){
            return {
                groups: [],
                loading: false,
                categories:[],
                commission:0,
                addProductCategoryToShop:{
                    groupId:"",
                    categoryId:""
                },
                selectedCategory:{},
                rules: {
                     
                    groupId: [
                        { required: true, message: 'Please choose your choice', trigger: 'change' }
                    ],
                    categoryId: [
                        { required: true, message: 'Please choose your choice', trigger: 'change' }
                    ],
                    
                },
                
            }
        },
        computed: mapGetters(['getProductGroupInfo','getCatalog']),
        methods:{
            ...mapActions(['getProductGroups','getProductCategories','addCategoryToShop','setProductGroupInfo','setStepCount']),
            filterOption(input, option) {
                  return (
                      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
            },
            onChangeGroup(id){
                // console.log("id | ", id)
                this.selectedGroupChange(id)
            },
            onChangeCategory(id){
                // console.log("id | ", id)
                // console.log("category | ", this.categories)
                let category = this.categories.filter(category => category.id == id)
                this.selectedCategory = category
                this.commission = category[0].commission
            },
            saveProductGroup(){
                this.$refs.addCategoryToShopForm.validate(valid => {
                    if (valid) {
                        // this.loading =true
                        let request_data  = {}
                        
                        if(this.selectedCategory[0].id === this.addProductCategoryToShop.categoryId){
                            
                            if(this.selectedCategory.isRestricted){
                                request_data['productCategoryId'] = this.selectedCategory[0].id
                                request_data['status'] = 2
                            }else{
                                request_data['productCategoryId'] = this.selectedCategory[0].id
                                request_data['status'] = 0
                            }

                            // console.log("request_data | ", request_data)
                            let productInfo = {
                                groupId: this.addProductCategoryToShop.groupId,
                                categoryId: this.addProductCategoryToShop.categoryId,
                                productId: this.getCatalog.id
                            }
                            // console.log("productInfo | ", productInfo)
                            this.setProductGroupInfo(productInfo)
                            this.setStepCount(1)
                            // this.$router.push(`/edit-product-details`).catch(()=>{});

                            // this.addCategoryToShop(request_data).then(response => {
                            //     this.loading = false
                            //     if(response.status == 200){
                            //         let productInfo = {
                            //             groupId: this.addProductCategoryToShop.groupId,
                            //             categoryId: this.addProductCategoryToShop.categoryId
                            //         }
                            //         this.setProductGroupInfo(productInfo)
                            //         // this.setStepCount(1)
                            //         // this.$router.push(`/product-details`).catch(()=>{});
                            //     }else{
                            //         this.loading = false
                            //         // console.log("Error | ", response)
                            //     }
                            // }, error => {
                            //     this.loading = false
                            //     console.log("Error | " , error)
                            // });
                            
                        }    
                    }else {
                        return false;
                    }
                })
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            selectedGroupChange(id){
                this.loading =  true;
                this.getProductCategories(id).then(response => {
                    
                    this.loading = false;
                    if(response.status === 200){
                        this.categories = response.data.data
                    }else{
                        this.loading = false;
                        console.log("Error | " , response)
                    }
                }, error => {
                    this.loading = false;
                    console.log("Error | " , error)
                });
            },
            getProductGrps(){
                this.loading =  true;
                this.getProductGroups().then(response => {
                    
                    if(response.status === 200){
                        this.loading = false;
                        this.groups = response.data.data;
                    }else{
                        this.loading = false;
                        this.showErrorAlert("Something went wrong");
                    }
                },error => {
                    this.loading = false;
                    console.log("Error | ", error)
                    this.showErrorAlert("Something went wrong");
                })
            }
        },
        created(){
            if(this.getProductGrps){
                this.getProductGrps();
            }
            if(this.getCatalog){
                // console.log("getCatalog | ", this.getCatalog)
                // this.onChangeGroup(this.getCatalog?.groupId)
                this.addProductCategoryToShop.groupId = this.getCatalog?.groupId
                this.addProductCategoryToShop.categoryId = this.getCatalog?.categoryId
                this.getProductCategories(this.getCatalog.groupId).then(response => {
                    
                    this.loading = false;
                    if(response.status === 200){
                        this.categories = response.data.data.filter(category => category.status === 0)
                        this.groupId = this.getCatalog?.groupId
                        this.categoryId = this.getCatalog?.categoryId
                        this.onChangeCategory(this.getCatalog?.categoryId)
                    }else{
                        this.loading = false;
                        console.log("Error | " , response)
                    }
                }, error => {
                    this.loading = false;
                    console.log("Error | " , error)
                });
            
            }
        
    }
    }
</script>

<style scoped>

.img_size{
    max-width: 56px;
    max-height: 55px;
}

.dropdownItem{
    width: 336px;
    border-radius: 5px;
}
</style>